<template>
  <div></div>
</template>
    
<script>
export default {
  name: "ListRefundsView",
  components: {},
};
</script>